import '@js/app'
import scrollbar from '@js/scrollbar'
import '@comp/animate_title/animate_title'
import '@comp/animate_title/animate_title.scss'

import '@css/base/policy.scss'
import { trackSection } from '@/scripts/ga'

$(() => {
    trackSection('Policy')
    scrollbar.init()

    $(document).on('click', '.scroll-link', function () {
        $('html, body').animate({ scrollTop: $($(this).attr('id')).offset().top - 88 }, 150)
    })
})
